export const BUTTON_LINK_ARIA_LABEL = 'Display auction item trend';
export const ITEM = 'Item';
export const TOP_BIDDER = 'Top bidder: ';
export const NO_BIDS_YET = 'No bids yet';
export const KG_BLUE_COLOR = 'interactive-kg-blue';
export const TOOLTIP_POSITION = 'right';
export const ITEM_LINK_ARIA_LABEL = 'Go to item details';
export const TOOL_TIP_ARIA_HIDDEN = 'true';
